import { Skeleton, TableCell, TableRow } from '@mui/material';

interface TableRowLoaderProps {
  rows: number;
  columns: number;
}

export const TableRowLoader = ({ rows, columns }: TableRowLoaderProps) => {
  return (
    <>
      {[...Array(rows)].map((_, index) => (
        <TableRow key={index}>
          {[...Array(columns)].map((_, index) => (
            <TableCell key={index}>
              <Skeleton animation="wave" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
